/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import React, { useContext, useEffect, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { FaStar } from 'react-icons/fa';
import { MdCheck, MdOutlineErrorOutline, MdOutlineFileDownload, MdOutlineRemoveRedEye, MdPictureAsPdf } from 'react-icons/md';
import Slider from "react-slick";
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent, {
    timelineOppositeContentClasses,
} from '@mui/lab/TimelineOppositeContent';
import HomeIcon from "../../assets/Icon/home.svg";
import testtube from "../../assets/Icon/testtube.svg";
import clockcircle from "../../assets/Icon/clock-circle.svg";
import invoice from "../../assets/Icon/invoice.svg";
import packagebox from "../../assets/Icon/package-box.svg";
import { showToast } from '../../showTost';
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
import ImageLoad from '../ImageLoad';
const PackageDetails = () => {

    const { t } = useTranslation();

    const { ApiBaseUrl, ImgBaseUrl, setIsLoginShow } = useContext(MyContext);
    const [labData, setLabData] = useState([]);
    const [appointData, setAppointData] = useState();
    const [isShow, setIsShow] = useState(false);
    const [statusList, setStatusList] = useState([]);
    const [detailsBox, setDetailsBox] = useState(false);
    const [packageData, setPackageData] = useState();
    const [showReport, setShowResport] = useState(false);
    const [reportData, setReportData] = useState();
    const [loading, setLoading] = useState(true);
    const [deviceCheck, setDeviceCheck] = useState(false);


    const location = useLocation();
    const Data = location.state;

    const site_currency = secureLocalStorage.getItem("currency");
    const currency = site_currency || "$";
    const Userid = secureLocalStorage.getItem("Userid");

    const settings = {
        arrows: false,
        dots: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            { breakpoint: 770, settings: { slidesToShow: 6 } },
            { breakpoint: 430, settings: { slidesToShow: 4 } },
        ],
    };

    useEffect(() => {
        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/lab_booking_detail`, { id: Userid, lab_book_id: Data.id })
                .then((res) => {
                    const { ResponseCode, lab, appoint } = res.data;
                    // console.log("lab_booking_detail", res);

                    if (ResponseCode === 200) {
                        setLabData(lab);
                        setAppointData(appoint);
                        HandleStatusGet(appoint);
                        setLoading(false);
                    }
                })
                .catch(console.error);
        }
    }, []);

    const HandleStatusGet = (appoint) => {
        const status = appoint?.status;
        const statusListRaw = appoint?.status_list || [];
        const isHomeCollection = appoint?.home_col_status === "0";

        let steps;

        if (status !== "7") {
            const OrderSteps = [
                { id: 1, title: "Pending", dis: t("YourOrderPlaced") },
                { id: 2, title: "Accepted", dis: t("OrderPending") },
                { id: 3, title: "Collector Assigned", dis: t("CollectorAssigned") },
                { id: 4, title: "Ongoing", dis: t("OrderDelivering") },
                { id: 5, title: "Processing", dis: t("ProductDelivered") },
                { id: 6, title: "Completed", dis: t("OrderDelivered") },
            ];

            steps = OrderSteps.filter(step => !(isHomeCollection && step.id === 3)).map((step) => {
                const match = statusListRaw.find(s => s.s === step.id);
                return {
                    ...step,
                    date: match?.t || "-",
                };
            });
        } else {
            steps = [
                { id: 1, title: "Pending", dis: t("YourOrderPlaced") },
                { id: 7, title: "Cancelled", dis: appoint?.cancel_reason || appoint?.cancel_title },

            ].map(step => {
                const match = statusListRaw.find(s => s.s === step.id);
                return {
                    ...step,
                    date: match?.t || "-",
                };
            });
        }

        setStatusList(steps);
    };

    const HandleShowResport = (item) => {
        if (item.r.length === 0) {
            showToast({ title: t("No lab report uploaded yet. You’ll be notified once it's available."), id: "warning" });
            return;
        }

        setShowResport(true);
        setReportData(item);
    };

    const HandleShowReport = (item) => {
        const url = ImgBaseUrl + item;
        window.open(url, "_blank");
    };

    const handleDownload = (img) => {
        const googleMapsUrl = ImgBaseUrl + img;
        window.open(googleMapsUrl, '_blank');
    };

    const formatDateTime = (dateStr, timeStr) => {
        const [day, month, year] = dateStr.split('-');

        const dateTimeString = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${convertTo24Hour(timeStr)}`;

        const date = new Date(dateTimeString);

        return date.toLocaleString('en-US', {
            weekday: 'short',
            month: 'short',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
        });
    };

    const convertTo24Hour = (timeStr) => {
        const [time, modifier] = timeStr.split(' ');
        let [hours, minutes] = time.split(':');

        if (modifier === 'PM' && hours !== '12') {
            hours = String(parseInt(hours, 10) + 12);
        }
        if (modifier === 'AM' && hours === '12') {
            hours = '00';
        }

        return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:00`;
    };

    const AudioCallHandler = async (code, phone) => {

        const Userid = secureLocalStorage.getItem("Userid");

        if (!Userid) {
            setIsLoginShow(true);
            return;
        }

        try {
            const deviceList = await navigator.mediaDevices.enumerateDevices();
            let hasMicrophone = false;

            deviceList.forEach(device => {
                if (device.kind === 'audioinput') {
                    hasMicrophone = true;
                }
            });

            if (!hasMicrophone) {
                setDeviceCheck(true);
                return;
            }

        } catch (error) {
            console.error('Error checking devices:', error);
        }

        window.location.href = `tel:${code + phone}`;
    };

    return (
        <div className='w-full width-container content-wrapper'>
            {loading
                ? <Loading CustomeStyle="h-[100vh] -mt-[140px] w-full flex items-center justify-center bg-white" index={0} />
                : <div className="">
                    <div className="flex items-center justify-center gap-[25px]">
                        <h1 className='font-[500]'>{t("Appointment ID")} : {Data.id}</h1>
                        <button onClick={() => { setIsShow(true); HandleStatusGet(appointData) }} className='text-[#4038FF] font-[500] border-[2px] border-[#4038FF] px-[10px] rounded-[50px]'>{t("Check Status")}</button>
                    </div>

                    <div className="order_details">
                        <div className="flex flex-wrap items-start justify-center gap-[20px] mt-[20px]">
                            <div className="width_box">

                                <div className="border-[1px] p-[10px] border-[#8080803b] rounded-[10px]">
                                    <h1 className='font-[500] text-[17px]'>{t("Lab Details")}</h1>
                                    <div className="mt-[5px] flex items-center gap-[10px]">
                                        <ImageLoad src={ImgBaseUrl + labData?.logo} CustomeStyle={"border-[1px] border-[#8080803b] rounded-[10px] w-[90px] h-[90px] object-cover"} alt={"logo"} />
                                        <div className="">
                                            <h1 className='font-[500] text-[17px]'>{labData?.name}</h1>
                                            <p>{labData?.address}</p>
                                            <div className="flex items-center gap-[5px]">
                                                <FaStar className='text-orange-400 text-[20px]' />
                                                <h1 className='font-[500] text-[18px]'>{labData?.avg_star}</h1>
                                                <span className='text-gray-500'>({labData?.tot_review}+ {t("Rating")})</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="border-[1px] p-[10px] border-[#8080803b] rounded-[10px] mt-[10px]">
                                    <h1 className='font-[500] text-[17px]'>{t("Test Details & Package Details")}</h1>
                                    <div className="">
                                        {appointData?.package_id.map((item, index) => {
                                            return <div key={index} className="border-[1px] p-[10px] border-[#8080803b] rounded-[10px] mt-[10px]">
                                                <div className="flex items-start gap-[10px] justify-between">
                                                    <div className="flex items-start gap-[10px]">
                                                        <ImageLoad src={ImgBaseUrl + item.logo} CustomeStyle={"w-[60px] h-[60px] min-w-[60px] object-cover rounded-[50px] border-[2px] border-[#8080807c]"} alt={"logo"} />
                                                        <div className="">
                                                            <h1 className='text-[17px] font-[500]'>{item.title}</h1>
                                                            <p className='text-[15px]'>{item.subtitle}</p>
                                                            <span className='text-gray-500 font-[500]'>{t("Includes")} {item.tot_package_name} {t("tests")}</span>
                                                            <div className="flex items-center gap-[10px] justify-between">
                                                                <h1>{t("Package Price")} : <span className='text-gray-500 font-[500]'>{currency} {item.tot_package_price} X {item.f.length}</span></h1>
                                                                <h1 className='font-[500]'>{currency} {item.tot_package_price * item.f.length}</h1>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button onClick={() => { setPackageData(item); setDetailsBox(true) }} className='text-[23px] text-[#4038FF]'><MdOutlineErrorOutline /></button>
                                                </div>
                                                <div className="slider-container mt-[10px]">
                                                    <Slider {...settings}>
                                                        {item.f.map((item, index) => {
                                                            return <div key={index} className="text-center family-box">
                                                                <ImageLoad src={ImgBaseUrl + item.fmember.profile_image} CustomeStyle={"w-[100%] h-[90px] object-cover rounded-[100%]"} alt={"profile_image"} />
                                                                <h1 className='font-[500]'>{item.fmember.name}</h1>
                                                                <button onClick={() => HandleShowResport(item)} className={`font-[500] text-[14px] ${item.r.length === 0 ? "bg-gray-400" : "bg-[#4038FF]"} text-white px-[10px] rounded-[30px]`}>{t("Report")}</button>
                                                            </div>
                                                        })}
                                                    </Slider>
                                                </div>
                                            </div>
                                        })}
                                    </div>
                                </div>

                            </div>
                            <div className="width_box">
                                {(appointData?.home_c_user && appointData?.home_c_email && appointData?.home_c_phone) && <div className="border-[1px] p-[10px] border-[#8080803b] rounded-[10px]">
                                    <div className="flex items-center justify-between">
                                        <h1 className='font-[500] text-[17px]'>{t("Home Collect Person")}</h1>
                                        <div onClick={(e) => AudioCallHandler(appointData?.home_c_ccode, appointData?.home_c_phone)} className="border-[1px] border-[#4038FF] rounded-[50px] p-[5px] cursor-pointer">
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="#4038FF" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M15 16L14.8529 16.7354C15.1846 16.8018 15.5196 16.6379 15.6708 16.3354L15 16ZM8 9L7.66459 8.32918C7.36208 8.48043 7.19824 8.81544 7.26456 9.14709L8 9ZM8.35402 8.82299L8.68943 9.49381L8.68943 9.49381L8.35402 8.82299ZM9.31654 6.29136L10.0129 6.01281L9.31654 6.29136ZM8.50289 4.25722L7.80653 4.53576L8.50289 4.25722ZM19.7428 15.4971L19.4642 16.1935L19.7428 15.4971ZM17.7086 14.6835L17.9872 13.9871H17.9872L17.7086 14.6835ZM15.177 15.646L15.8478 15.9814V15.9814L15.177 15.646ZM16.25 11C16.25 11.4142 16.5858 11.75 17 11.75C17.4142 11.75 17.75 11.4142 17.75 11H16.25ZM16.6955 9.46927L17.3884 9.18225L16.6955 9.46927ZM14.5307 7.30448L14.8177 6.61157L14.5307 7.30448ZM13 6.25C12.5858 6.25 12.25 6.58579 12.25 7C12.25 7.41421 12.5858 7.75 13 7.75V6.25ZM20.25 11C20.25 11.4142 20.5858 11.75 21 11.75C21.4142 11.75 21.75 11.4142 21.75 11H20.25ZM20.391 7.93853L21.0839 7.65152L20.391 7.93853ZM16.0615 3.60896L16.3485 2.91605V2.91605L16.0615 3.60896ZM13 2.25C12.5858 2.25 12.25 2.58579 12.25 3C12.25 3.41421 12.5858 3.75 13 3.75V2.25ZM20.25 17.3541V19H21.75V17.3541H20.25ZM5 3.75H6.64593V2.25H5V3.75ZM15 16C15.1471 15.2646 15.1473 15.2646 15.1475 15.2646C15.1476 15.2647 15.1477 15.2647 15.1479 15.2647C15.1481 15.2648 15.1483 15.2648 15.1484 15.2648C15.1487 15.2649 15.1488 15.2649 15.1488 15.2649C15.1488 15.2649 15.1482 15.2648 15.147 15.2645C15.1447 15.264 15.14 15.2631 15.1331 15.2615C15.1193 15.2585 15.0967 15.2533 15.0659 15.2459C15.0044 15.2309 14.9104 15.2066 14.7898 15.1711C14.5482 15.1 14.2016 14.9847 13.7954 14.8106C12.9796 14.461 11.9439 13.8833 11.0303 12.9697L9.96967 14.0303C11.0561 15.1167 12.2704 15.789 13.2046 16.1894C13.6734 16.3903 14.0768 16.525 14.3665 16.6101C14.5115 16.6528 14.6285 16.6832 14.7114 16.7034C14.7529 16.7135 14.7859 16.721 14.8097 16.7263C14.8217 16.7289 14.8313 16.7309 14.8385 16.7325C14.8421 16.7332 14.8451 16.7339 14.8475 16.7343C14.8487 16.7346 14.8498 16.7348 14.8507 16.735C14.8511 16.7351 14.8515 16.7352 14.8519 16.7352C14.8521 16.7353 14.8523 16.7353 14.8524 16.7353C14.8527 16.7354 14.8529 16.7354 15 16ZM11.0303 12.9697C10.1167 12.0561 9.53901 11.0204 9.18936 10.2046C9.01527 9.79836 8.89996 9.45184 8.8289 9.21025C8.79342 9.08962 8.76912 8.99565 8.75414 8.93406C8.74666 8.90329 8.74151 8.88065 8.73847 8.86687C8.73695 8.85999 8.73595 8.85532 8.73546 8.85296C8.73521 8.85178 8.73509 8.85118 8.73508 8.85117C8.73508 8.85116 8.73511 8.8513 8.73517 8.85159C8.7352 8.85174 8.73524 8.85192 8.73528 8.85214C8.7353 8.85225 8.73534 8.85244 8.73535 8.8525C8.73539 8.8527 8.73544 8.85291 8 9C7.26456 9.14709 7.26461 9.14732 7.26466 9.14756C7.26468 9.14765 7.26473 9.1479 7.26477 9.14809C7.26484 9.14846 7.26492 9.14887 7.26501 9.14932C7.2652 9.15022 7.26541 9.15127 7.26566 9.15247C7.26615 9.15488 7.26677 9.15789 7.26753 9.1615C7.26905 9.16873 7.27111 9.17834 7.27374 9.19026C7.279 9.21408 7.28655 9.2471 7.29664 9.28859C7.31682 9.37154 7.34721 9.48851 7.38985 9.6335C7.47504 9.92316 7.60973 10.3266 7.81064 10.7954C8.21099 11.7296 8.88325 12.9439 9.96967 14.0303L11.0303 12.9697ZM8.33541 9.67082L8.68943 9.49381L8.01861 8.15217L7.66459 8.32918L8.33541 9.67082ZM10.0129 6.01281L9.19925 3.97868L7.80653 4.53576L8.62018 6.5699L10.0129 6.01281ZM20.0213 14.8008L17.9872 13.9871L17.4301 15.3798L19.4642 16.1935L20.0213 14.8008ZM14.5062 15.3106L14.3292 15.6646L15.6708 16.3354L15.8478 15.9814L14.5062 15.3106ZM17.9872 13.9871C16.6592 13.4559 15.1458 14.0313 14.5062 15.3106L15.8478 15.9814C16.1386 15.3999 16.8265 15.1384 17.4301 15.3798L17.9872 13.9871ZM8.68943 9.49381C9.96868 8.85419 10.5441 7.34076 10.0129 6.01281L8.62018 6.5699C8.86163 7.17351 8.60008 7.86143 8.01861 8.15217L8.68943 9.49381ZM6.64593 3.75C7.15706 3.75 7.6167 4.06119 7.80653 4.53576L9.19925 3.97868C8.78162 2.93462 7.77042 2.25 6.64593 2.25V3.75ZM21.75 17.3541C21.75 16.2296 21.0654 15.2184 20.0213 14.8008L19.4642 16.1935C19.9388 16.3833 20.25 16.8429 20.25 17.3541H21.75ZM19 20.25C10.5777 20.25 3.75 13.4223 3.75 5H2.25C2.25 14.2508 9.74923 21.75 19 21.75V20.25ZM19 21.75C20.5188 21.75 21.75 20.5188 21.75 19H20.25C20.25 19.6904 19.6904 20.25 19 20.25V21.75ZM3.75 5C3.75 4.30964 4.30964 3.75 5 3.75V2.25C3.48122 2.25 2.25 3.48122 2.25 5H3.75ZM17.75 11C17.75 10.3762 17.6271 9.75855 17.3884 9.18225L16.0026 9.75628C16.1659 10.1506 16.25 10.5732 16.25 11H17.75ZM17.3884 9.18225C17.1497 8.60596 16.7998 8.08232 16.3588 7.64124L15.2981 8.7019C15.5999 9.00369 15.8393 9.36197 16.0026 9.75628L17.3884 9.18225ZM16.3588 7.64124C15.9177 7.20016 15.394 6.85028 14.8177 6.61157L14.2437 7.99739C14.638 8.16072 14.9963 8.40011 15.2981 8.7019L16.3588 7.64124ZM14.8177 6.61157C14.2415 6.37286 13.6238 6.25 13 6.25V7.75C13.4268 7.75 13.8494 7.83406 14.2437 7.99739L14.8177 6.61157ZM21.75 11C21.75 9.85093 21.5237 8.71312 21.0839 7.65152L19.6981 8.22554C20.0625 9.10516 20.25 10.0479 20.25 11H21.75ZM21.0839 7.65152C20.6442 6.58992 19.9997 5.62533 19.1872 4.81282L18.1265 5.87348C18.7997 6.5467 19.3338 7.34593 19.6981 8.22554L21.0839 7.65152ZM19.1872 4.81282C18.3747 4.0003 17.4101 3.35578 16.3485 2.91605L15.7745 4.30187C16.6541 4.66622 17.4533 5.20025 18.1265 5.87348L19.1872 4.81282ZM16.3485 2.91605C15.2869 2.47633 14.1491 2.25 13 2.25V3.75C13.9521 3.75 14.8948 3.93753 15.7745 4.30187L16.3485 2.91605Z" />
                                            </svg>
                                        </div>
                                    </div>
                                    <ul>
                                        <li className='text-gray-500 text-[15px] font-[500]'>{t("Name")} : <span className='text-gray-700'>{appointData?.home_c_user}</span> </li>
                                        <li className='text-gray-500 text-[15px] font-[500]'>{t("Email")} : <span className='text-gray-700'>{appointData?.home_c_email}</span> </li>
                                        <li className='text-gray-500 text-[15px] font-[500]'>{t("Phone Number")} : <span className='text-gray-700'>{appointData?.home_c_ccode} {appointData?.home_c_phone}</span> </li>
                                    </ul>
                                </div>
                                }

                                <div className="border-[1px] p-[10px] border-[#8080803b] rounded-[10px] mt-[10px]">
                                    <h1 className='font-[500] text-[17px]'>{t("Booking Date & Time Info")}</h1>
                                    <p className='text-gray-500 text-[15px] font-[500]'>{t("Booking")} : <span className="text-gray-700">{appointData?.date}</span> </p>
                                </div>

                                <div className="border-[1px] p-[10px] border-[#8080803b] rounded-[10px] mt-[10px]">
                                    <h1 className='font-[500] text-[17px]'>{t("Appointment Date & Time Info")}</h1>
                                    <p className='text-gray-500 text-[15px] font-[500]'>{t("Appointment")} : <span className="text-gray-700">{formatDateTime(appointData?.book_date, appointData?.book_time)}</span> </p>
                                </div>

                                <div className="border-[1px] p-[10px] border-[#8080803b] rounded-[10px] mt-[10px]">
                                    <h1 className='font-[500] text-[17px]'>{t("Bill Summary")}</h1>
                                    <div className="">
                                        <ul>
                                            <li className="font-medium text-gray-500 py-1">
                                                {t("Package Charge")}: <span className="text-gray-700">{currency} {appointData?.tot_package_price}</span>
                                            </li>

                                            <li className="font-medium text-gray-500 py-1">
                                                {t("Total Price")}: <span className="text-gray-700">{currency} {appointData?.tot_price}.0</span>
                                            </li>

                                            {appointData?.home_extra_price !== 0 && (
                                                <li className="font-medium text-gray-500 py-1">
                                                    {t("Home Collection Fee")}: <span className="text-gray-700">{currency} {appointData?.home_extra_price}</span>
                                                </li>
                                            )}

                                            {(appointData?.payment_name && appointData?.payment_name !== "Cash") && (
                                                <li className="font-medium text-gray-500 py-1">
                                                    {t("Payment")} <span className="text-gray-700">({appointData?.payment_name}): {currency} {appointData?.online_amount}.0</span>
                                                </li>
                                            )}

                                            {appointData?.wallet_amount !== 0 && (
                                                <li className="font-medium text-gray-500 py-1">
                                                    {t("Wallet Amount")}: <span className="text-gray-700">{currency} {appointData?.wallet_amount}.0</span>
                                                </li>
                                            )}

                                            {appointData?.coupon_amount !== 0 && (
                                                <li className="font-medium text-gray-500 py-1">
                                                    {t("Coupon Amount")}: <span className="text-gray-700">{currency} {appointData?.coupon_amount}.0</span>
                                                </li>
                                            )}

                                            <li className="font-medium text-gray-500 py-1">
                                                {t("Service Fee & Tax")}: <span className="text-gray-700">{currency} {appointData?.site_commission}.0</span>
                                            </li>

                                            <li className="font-medium text-gray-500 py-1">
                                                {t("TransactionId")}: <span className="text-gray-700">{appointData?.transactionId}</span>
                                            </li>
                                        </ul>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>}

            {isShow && <div onClick={() => setIsShow("")} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
                <div style={{ borderRadius: "10px 10px 0 0" }} onClick={(e) => e.stopPropagation()} className="bottme-box ">
                    <h1 className='font-[500] text-[18px]'>{t("Order Status")}</h1>
                    <div className="">
                        <Timeline
                            sx={{
                                [`& .${timelineOppositeContentClasses.root}`]: {
                                    flex: 0.2,
                                },
                            }}
                        >
                            {statusList.map((item, index) => {
                                const status = Number(appointData?.status);
                                const isFilled = status >= String(item.id);
                                const timelineDotColor = isFilled ? "#4038FF" : "#bdbdbd";
                                return (
                                    <div key={index}>
                                        <TimelineItem>
                                            <TimelineOppositeContent color="textSecondary">
                                                <h1 className='w-[70px]'>{item.date}</h1>
                                            </TimelineOppositeContent>
                                            <TimelineSeparator>
                                                <div style={{ backgroundColor: isFilled ? "#4038FF" : "white" }} className="border-[1px] my-[11.5px] border-[#8080807c] rounded-[8px] p-[2px]">
                                                    <MdCheck className='text-[16px] text-white' />
                                                </div>
                                                {statusList.length !== (index + 1) && <TimelineConnector style={{ backgroundColor: timelineDotColor }} />}
                                            </TimelineSeparator>
                                            <TimelineContent>
                                                <h1 className="font-[500] text-[18px]">{t(item.title)}</h1>
                                                <p className="text-gray-500 text-[15px]">{item.dis}</p>
                                            </TimelineContent>
                                        </TimelineItem>
                                    </div>
                                );
                            })}
                        </Timeline>
                    </div>
                </div>
            </div>}

            {detailsBox && <div onClick={() => setDetailsBox("")} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
                <div style={{ borderRadius: "10px 10px 0 0" }} onClick={(e) => e.stopPropagation()} className="bottme-box max-h-[600px] scroll-container">
                    <h1 className='font-[500] text-[17px] mb-[5px]'>{t("Test Details & Package Details")}</h1>
                    <div className="border-t-[2px] border-dashed border-[#8080803b] pt-[10px]">
                        <div className="">
                            <div className="flex items-center gap-[10px]">
                                <div className="flex items-center gap-[10px]">
                                    <img src={HomeIcon} className='w-[20px]' alt="" />
                                    <h1 className='font-[500]'>{t("Home Collect Extra Price")}</h1>
                                </div>
                                <h1 className='bg-blue-100 border-[2px] border-[#8080803b] px-[10px] py-[1px] font-[500] rounded-[5px]'>{currency} {packageData?.home_extra_price}</h1>
                            </div>
                            <div className="flex items-center gap-[10px] mt-[5px]">
                                <div className="flex items-center gap-[10px]">
                                    <img src={testtube} className='w-[20px]' alt="" />
                                    <h1 className='font-[500] leading-[18px]'>{t("Sample Type")}</h1>
                                </div>
                                <div className="bg-blue-100 border-[2px] max-w-[300px] border-[#8080803b] px-[10px] py-[1px] rounded-[5px] flex flex-wrap items-center gap-[10px]">
                                    {packageData?.sample_type.map((item, index) => {
                                        return <h1 key={index} className='font-[500] leading-[18px] py-[3px]'>{item},</h1>
                                    })}
                                </div>
                            </div>
                            <div className="flex items-center gap-[10px] mt-[5px]">
                                <div className="flex items-center gap-[10px]">
                                    <img src={HomeIcon} className='w-[20px]' alt="" />
                                    <h1 className='font-[500]'>{t("Fasting Required")}</h1>
                                </div>
                                <h1 className='bg-blue-100 border-[2px] border-[#8080803b] px-[10px] py-[1px] font-[500] rounded-[5px]'>{packageData?.fasting_require}</h1>
                            </div>
                            <div className="flex items-center gap-[10px] mt-[5px]">
                                <div className="flex items-center gap-[10px]">
                                    <img src={clockcircle} className='w-[20px]' alt="" />
                                    <h1 className='font-[500]'>{t("Test Report Time")}</h1>
                                </div>
                                <h1 className='bg-blue-100 border-[2px] border-[#8080803b] px-[10px] py-[1px] font-[500] rounded-[5px]'>{packageData?.test_report_time}</h1>
                            </div>
                        </div>

                        <div className="mt-[20px]">
                            <div className="">
                                <div className="flex items-center gap-[10px]">
                                    <img src={invoice} className='w-[20px]' alt="" />
                                    <h1 className='font-[500] text-[17px]'>{t("Package Description")}</h1>
                                </div>
                                <p className='px-[10px]'>{packageData?.description}</p>
                            </div>

                            <div className="flex items-center justify-between mt-[10px]">
                                <div className="flex items-center gap-[10px]">
                                    <img src={packagebox} className='w-[20px]' alt="" />
                                    <h1 className='font-[500] text-[17px]'>{t("Package Includes")}</h1>
                                </div>
                                <h1 className='font-[500] text-[18px]'>{currency} {packageData?.package_price.reduce((acc, curr) => acc + curr, 0)}</h1>
                            </div>
                            <div className="ps-[18px]">
                                {packageData?.package_name.map((item, index) => {
                                    return <div key={index} className="flex items-center justify-between">
                                        <li>{item}</li>
                                        <span>$ {packageData?.package_price[index]}</span>
                                    </div>
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }

            {showReport && <div onClick={() => setShowResport(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="bottme-box max-h-[600px] scroll-container">
                    <h1 className='font-[500] text-[18px]'>{t("Report")}</h1>

                    <div className="mt-[10px] flex items-center gap-[10px] px-[10px]">
                        <div className="border-[1px] border-[#4038FF] rounded-[50px] p-[5px]">
                            <ImageLoad src={ImgBaseUrl + reportData?.fmember.profile_image} CustomeStyle={"w-[55px] h-[55px] object-cover rounded-[50px]"} alt={"profile_image"} />
                        </div>
                        <div className="">
                            <h1 className='font-[500] text-[17px]'>{reportData?.fmember.name}</h1>
                            <span className='text-gray-500'>{reportData?.d}</span>
                        </div>
                    </div>

                    <div className="">
                        {reportData?.r.map((item, index) => {
                            const imageExtensions = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'];
                            const itemSplit = item.split(".")[1];
                            if (imageExtensions.includes(itemSplit)) {
                                return <div key={index} className="flex items-center gap-[10px] mt-[10px]">
                                    <div className="border-[1px] border-[#4038FF] p-[5px] rounded-[10px] w-[90%]">
                                        <div className="flex items-center gap-[10px]">
                                            <div className="bg-gray-200 rounded-[5px] p-[3px]">
                                                <MdPictureAsPdf className='text-[#4038FF] text-[25px]' />
                                            </div>
                                            <h1 className='text-[#4038FF] whitespace-nowrap overflow-hidden overflow-ellipsis'>{item}</h1>
                                        </div>
                                    </div>
                                    <button onClick={() => HandleShowReport(item)} className="bg-[#4038FF] p-[8px] rounded-[50px]">
                                        <MdOutlineRemoveRedEye className='text-white text-[20px]' />
                                    </button>
                                </div>
                            } else {
                                return <div key={index} className="flex items-center gap-[10px] mt-[10px]">
                                    <div className="border-[1px] border-[#4038FF] p-[5px] rounded-[10px] w-[80%]">
                                        <div className="flex items-center gap-[10px]">
                                            <div className="bg-gray-200 rounded-[5px] p-[3px]">
                                                <MdPictureAsPdf className='text-[#4038FF] text-[25px]' />
                                            </div>
                                            <h1 className='text-[#4038FF] whitespace-nowrap overflow-hidden overflow-ellipsis'>{item}</h1>
                                        </div>
                                    </div>
                                    <button onClick={() => HandleShowReport(item)} className="bg-[#4038FF] p-[8px] rounded-[50px]">
                                        <MdOutlineRemoveRedEye className='text-white text-[20px]' />
                                    </button>
                                    <button onClick={() => handleDownload(item)} className="bg-[#4038FF] p-[8px] rounded-[50px]">
                                        <MdOutlineFileDownload className='text-white text-[20px]' />
                                    </button>
                                </div>
                            }
                        })}
                    </div>

                    <div className="mt-[10px]">
                        <h1 className='font-[500] text-gray-500 text-[17px]'>{t("Comment")} : <span className='font-normal text-[16px] text-gray-700'>{reportData?.c}</span> </h1>
                    </div>

                </div>
            </div>}

            {deviceCheck && <div onClick={() => setDeviceCheck(false)} className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-[15px] p-4">
                    <h6 className='m-0 font-[500] text-[18px] text-gray-600'>{t("Required for voice and video calls. Make")} <br /> {t("sure your audio device (headset, speakers,")} <br /> {t("or microphone) is connected and working.")}</h6>
                </div>
            </div>}

        </div >
    )
}

export default PackageDetails
/* jshint ignore:end */